import './Dashboard.css';
import { useSelector } from 'react-redux';
import { selectSelectedOrganization } from '../stateManagement/selectedOrganizationSlice';
import { selectSelectedServiceProvider } from '../stateManagement/selectedServiceProviderSlice';
import CoreMenu from './menu/CoreMenu';
import OrganizationList from './organization/OrganizationList';
import ServiceProviderList from './serviceProvider/ServiceProviderList';
import AppointmentList from './appointment/AppointmentList';

import ServiceProviderAvailabilityListDialog from './serviceProviderAvailability/ServiceProviderAvailabilityListDialog';

const Dashboard: React.FC = () => {

    const selectedOrganization = useSelector(selectSelectedOrganization);
    const selectedServiceProvider = useSelector(selectSelectedServiceProvider);

   /* if (!target) {
        return <>
            <CoreMenu />
            <Box sx={{
                width: '100vw',
                height: 'calc(100vh - 70px)',
                paddingTop: '15rem',
                backgroundColor: 'background.paper',
                color: 'text.primary',
            }}>
                <Container component="main" maxWidth="xs">
                    <Paper style={{ padding: '2rem' }} elevation={3}>
                        <Typography variant="h5" gutterBottom>
                            What would you like to do?
                        </Typography>
                        <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center' >
                            <InfoComponent
                                infoContent="As an admin or organization manager, you can:
- Create and manage places (e.g., clinics, salons).
- Add and manage service providers.
- Define services and set availability.
- View and manage appointments using timesheets.
- Add clients and book appointments directly.
- Edit existing bookings and manage your calendar."
                            >
                                <Button
                                    variant="contained"
                                    sx={{ mt: 1, textTransform: 'none', display: 'flex', justifyContent: 'start', width: '220px' }}
                                    onClick={() => dispatch(setTarget('manageOrganizations'))}
                                >
                                    <StoreIcon sx={{ marginRight: '10px' }} /> <div>Manage my places</div>
                                </Button>
                            </InfoComponent>
                            <InfoComponent
                                infoContent="As a client, you can:
- Search for places (clinics, salons, etc.) offering appointments.
- Choose a place and view its service providers.
- See available time slots using the calendar.
- Book a pending appointment and wait for confirmation.
- View all your appointments and track their status (Pending, Confirmed, etc.)."
                            >
                                <Button
                                    variant="contained"
                                    sx={{ mt: 1, textTransform: 'none', display: 'flex', justifyContent: 'start', width: '220px' }}
                                    onClick={() => dispatch(setTarget('bookAppointment'))}
                                >
                                    <InsertInvitationIcon sx={{ marginRight: '10px' }} /> <div>Book an appointment</div>
                                </Button>
                            </InfoComponent>
                        </Box>
                    </Paper>
                </Container>
            </Box>
        </>
    }
    else if (target === 'bookAppointment') {
        if (publicUserMenu === 'AppointmentList') {
            return <>
                <CoreMenu />
                <PublicUserAppointmentList /> 
            </>
        }
        else if (publicUserMenu === 'FavoriteOrganization') {
            return <>
                <CoreMenu />
                 <PublicUserFavoriteOrganizationList /> 
            </>
        }
        else {
            if (!selectedOrganizationForUser.organizationId) {
                return <>
                    <CoreMenu />
                     <PublicUserOrganizationList /> 
                </>
            }
            else {
                if (!selectedServiceProviderForUser.serviceProviderId) {
                    return <>
                        <CoreMenu />
                         <PublicUserServiceProviderList /> 
                    </>
                }
                else {
                    return <>
                        <CoreMenu />
                         <PublicUserServiceProviderTimeList /> 
                    </>
                }
            }
        }
    }
    else */if (!selectedOrganization.organizationId) {
        return (
            <>
                <CoreMenu />
                <OrganizationList />

            </>
        );
    } else if (!selectedServiceProvider.serviceProviderId) {
        return (
            <>
                <CoreMenu />
                <ServiceProviderList />
                {/* <OrganizationTaskList /> */}
                {/* <LoyaltyPointList /> */}
                {/* <ClientList state={'mount'} loading={loading} setLoading={setLoading} showInfoToggleButton={true} /> */}
            </>
        );
    }

    return (
        <>
            <CoreMenu />
            <ServiceProviderAvailabilityListDialog />
            <AppointmentList />
        </>
    );
};

export default Dashboard;